// extracted by mini-css-extract-plugin
export default {"bannerContainer":"styleModule_bannerContainer__30YeY","bannerImage":"styleModule_bannerImage__vmwC2"};